module.exports = {"sld:ColorMapEntry":[{"color":"#0074ad","label":"< 2.60343","quantity":0.02603},{"color":"#9dc4b5","label":" 2.60343- 3.67209","quantity":0.03672},{"color":"#e6efc3","label":" 3.67209- 4.63737","quantity":0.04637},{"color":"#ffe89e","label":" 4.63737- 5.96012","quantity":0.0596},{"color":"#f5af7f","label":" 5.96012- 7.78311","quantity":0.07783},{"color":"#ed6d32","label":" 7.78311- 19.60786","quantity":0.19608}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/fxfl_raster/maize_MME_1981_2016_lcr_90_return_20.json
// module id = nLh/
// module chunks = 171